import _ from 'lodash';
import * as types from '../mutation-types';
import { SOCKET_BACKUPUPDATENOTIFICATION } from '../mutation-types';

const state = {
  version: '2.0.21',
  device: {
    isMobile: false,
    isTablet: false,
  },
  sidebar: {
    opened: false,
    hidden: false,
  },
  notificationSidebar: {
    opened: false,
    hidden: false,
  },
  effect: {
    translate3d: true,
  },
  apiEndpoint: process.env.VUE_APP_KOALABOSS_API,
  authenticatedUser: {},
  clientRoles: [],
  adminRoles: [],
  allRoles: [],
  awsRegions: [],
  pluginUrl: '',
  messages: [],
  isConnected: false,
  notifications: {
    globalMessages: [],
    organisationMessages: {
      siteUpdates: [],
      pluginUpdates: [],
      themeUpdates: [],
      stats: {
        sitesUpdating: 0,
        sitesCompleted: 0,
        sitesUpdateWithError: 0,
        sitesQueued: 0,
      },
    },
  },
};

const mutations = {
  SOCKET_CONNECT: (state, status) => {
    // console.log('connect')
    // socket.emit('room', data.data.user.organisationId)
    state.isConnected = true;
  },
  SOCKET_GLOBALNOTIFICATION: (state, message) => {
    state.notifications.globalMessages.push(message);
  },
  [types.QUEUE_SITE_UPDATE]: (state, data) => {
    const { siteUpdates } = state.notifications.organisationMessages;
    const { stats } = state.notifications.organisationMessages;
    const site = _.find(siteUpdates, { siteId: data.siteId });
    const newMessage = {
      action: 'Site update queued',
      actionDisplay: 'Site update queued',
      status: null,
      error: null,
    };
    if (!site) {
      siteUpdates.unshift({
        siteId: data.siteId,
        name: data.siteName,
        updateComplete: false,
        updateQueued: true,
        messages: [newMessage],
      });
    } else {
      site.messages.unshift({
        action: '',
        actionDisplay: '<hr>',
        status: null,
        error: null,
      });
      site.messages.unshift(newMessage);
    }
    stats.sitesQueued++;
  },
  SOCKET_SITEUPDATENOTIFICATION: (state, data) => {
    const { siteUpdates } = state.notifications.organisationMessages;
    const { stats } = state.notifications.organisationMessages;
    let site = _.find(siteUpdates, { siteId: data.siteId });

    if (!site) {
      siteUpdates.unshift({
        siteId: data.siteId,
        name: data.siteName,
        updateComplete: false,
        messages: [],
      });
      site = _.find(siteUpdates, { siteId: data.siteId });
    }
    if (data.action === 'start-site-update') {
      site.updateQueued = false;
      site.updateComplete = false;
      stats.sitesUpdating++;
    }
    site.pluginUpdatesRemainingCount = data.updateStats.pluginUpdatesRemainingCount;
    site.pluginUpdatesErrorCount = data.updateStats.pluginUpdatesErrorCount;
    site.pluginUpdatesRemainingPercentage = data.updateStats.pluginUpdatesRemainingPercentage;
    if (data.action === 'no-plugins-found') {
      site.pluginUpdatesRemainingPercentage = 100;
      stats.sitesUpdating--;
      stats.sitesCompleted++;
    }
    if (data.action === 'end-site-update') {
      site.updateComplete = true;
      stats.sitesUpdating--;
      if (stats.pluginUpdatesErrorCount > 0) {
        stats.sitesUpdateWithError++;
      } else {
        stats.sitesCompleted++;
      }
    }
    site.messages.unshift({
      action: data.action,
      actionDisplay: data.actionDisplay,
      status: data.status,
      error: data.error,
    });
  },
  SOCKET_SITETHEMEUPDATENOTIFICATION: (state, data) => {
    const { siteUpdates } = state.notifications.organisationMessages;
    const { stats } = state.notifications.organisationMessages;
    let site = _.find(siteUpdates, { siteId: data.siteId });

    if (!site) {
      siteUpdates.unshift({
        siteId: data.siteId,
        name: data.siteName,
        updateComplete: false,
        messages: [],
      });
      site = _.find(siteUpdates, { siteId: data.siteId });
    }
    if (data.action === 'start-theme-update') {
      site.pluginUpdatesRemainingPercentage = 0;
      site.updateQueued = false;
      site.updateComplete = false;
      stats.sitesUpdating++;
    }
    if (data.action === 'end-theme-update') {
      site.pluginUpdatesRemainingPercentage = 100;
      site.updateComplete = true;
      stats.sitesUpdating--;
      if (data.error) {
        stats.sitesUpdateWithError++;
      } else {
        stats.sitesCompleted++;
      }
    }
    site.messages.unshift({
      action: data.action,
      actionDisplay: data.actionDisplay,
      status: data.status,
      error: data.error,
    });
  },
  SOCKET_PLUGINUPDATENOTIFICATION: (state, data) => {
    const { siteUpdates } = state.notifications.organisationMessages;
    const { stats } = state.notifications.organisationMessages;
    let site = _.find(siteUpdates, { siteId: data.siteId });

    if (!site) {
      siteUpdates.unshift({
        siteId: data.siteId,
        name: data.siteName,
        updateComplete: false,
        messages: [],
      });
      site = _.find(siteUpdates, { siteId: data.siteId });
    }
    if (data.action === 'start-plugin-update') {
      site.updateQueued = false;
      site.updateComplete = false;
      stats.sitesUpdating++;
    }

    if (data.action === 'end-plugin-update') {
      site.pluginUpdatesRemainingCount = 0;
      site.pluginUpdatesRemainingPercentage = 100;
      site.updateComplete = true;
      stats.sitesUpdating--;
      if (!data.status) {
        stats.sitesUpdateWithError++;
      } else {
        stats.sitesCompleted++;
      }
    }
    site.messages.unshift({
      action: data.action,
      actionDisplay: data.actionDisplay,
      status: data.status,
      error: data.error,
    });
  },
  SOCKET_BACKUPUPDATENOTIFICATION: (state, data) => {
    // console.log(data);
    // @TODO - Add to app wide backup notification?
  },
  [types.CLEAR_SITE_NOTIFICATIONS](state) {
    state.notifications.organisationMessages.siteUpdates = [];
  },
  [types.TOGGLE_DEVICE](state, device) {
    state.device.isMobile = device === 'mobile';
    state.device.isTablet = device === 'tablet';
  },
  [types.TOGGLE_SIDEBAR](state, config) {
    if (state.device.isMobile && config.hasOwnProperty('opened')) {
      state.sidebar.opened = config.opened;
    } else {
      state.sidebar.opened = true;
    }

    if (config.hasOwnProperty('hidden')) {
      state.sidebar.hidden = config.hidden;
    }
  },
  [types.TOGGLE_NOTIFICATIONS](state, config) {
    if (config.hasOwnProperty('opened')) {
      state.notificationSidebar.opened = config.opened;
    } else {
      state.notificationSidebar.opened = true;
    }

    if (config.hasOwnProperty('hidden')) {
      state.notificationSidebar.hidden = config.hidden;
    }
  },
  [types.SWITCH_EFFECT](state, effectItem) {
    for (const name in effectItem) {
      state.effect[name] = effectItem[name];
    }
  },

  // Set all required app data from api
  setAppData(state, data) {
    state.authenticatedUser = data.user;
    state.clientRoles = data.app.clientRoles;
    state.adminRoles = data.app.adminRoles;
    state.awsRegions = data.app.awsRegions;
    state.allRoles = state.clientRoles.concat(state.adminRoles);
    state.pluginUrl = data.app.pluginUrl;
  },
  updateOrganisationBackupRegion(state, data) {
    _.set(state.authenticatedUser, 'organisation.backup.defaultS3Region', data.awsRegion);
  },
};

export default {
  state,
  mutations,
};
